import { render, staticRenderFns } from "./Incoming.vue?vue&type=template&id=c54de940&"
import script from "./Incoming.vue?vue&type=script&lang=js&"
export * from "./Incoming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports